import { render, staticRenderFns } from "./TableMarginConfig.vue?vue&type=template&id=a8586ab2&scoped=true"
import script from "./TableMarginConfig.vue?vue&type=script&lang=js"
export * from "./TableMarginConfig.vue?vue&type=script&lang=js"
import style0 from "./TableMarginConfig.vue?vue&type=style&index=0&id=a8586ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8586ab2",
  null
  
)

export default component.exports